import React from 'react';

const SHEET_NO_LIST = [1, 2] as const;

interface KioskWorkStandardButtonFormProps {
  onClick: (sheetNo: 1 | 2) => void;
  // aria-disabled로만 표시한다. 클릭은 막지 않으며, 선택 여부 검사는 onClick 쪽에서 한다.
  isDisabled?: boolean;
  // 크기·모서리 클래스. 넘기면 기본값 전체를 대체한다.
  buttonStyle?: string;
}

export const KioskWorkStandardButtonForm: React.FC<KioskWorkStandardButtonFormProps> = ({
  onClick,
  isDisabled = false,
  buttonStyle = "h-[38px] w-[92px] rounded-[8px]",
}) => {
  return (
    <div className="flex shrink-0 items-center gap-[6px]">
      {SHEET_NO_LIST.map(sheetNo => (
        <button
          key={sheetNo}
          type="button"
          className={`${buttonStyle} shrink-0 cursor-pointer overflow-hidden hover:brightness-110 active:brightness-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1646b8]`}
          aria-disabled={isDisabled}
          aria-label={`표준${sheetNo}`}
          onClick={() => onClick(sheetNo)}
        >
          <img src={`/images/icon/work-standard-${sheetNo}.png`} alt="" className="h-full w-full scale-110 object-cover" draggable={false} />
        </button>
      ))}
    </div>
  );
};
